<template>
	<!-- <f7-page class=""> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <f7-fab class="leftfav button-fab button-fab bottomButton floatingButtonToolbarBlank fab-extended floating-button" href="/settings/remind/add/">
      <i class="icon f7-icons">add</i>
      <span class="showLargeScreenOnly fab-label">Add reminder</span>
    </f7-fab>

    <div class="page-content">

      <!-- <f7-fab class="blueBackground">
  			<f7-icon f7="add"></f7-icon>
  		</f7-fab> -->

      <!-- <page-nav-bar currentServiceName="MoneyRoad" popoverName=".popoverSendbox" subNavTitle="Remind Settings" :returnPreviousPage="true">
      </page-nav-bar> -->

  		<f7-searchbar class="search"
  			cancel-link="Cancel"
        placeholder="Search in Remind Settings"
  			search-list="remind-setting-list">
  		</f7-searchbar>
  		<div class="layoutSubtitle"/>
      <cm-remind-setting-list :remindSettings="remindSettings"></cm-remind-setting-list>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
// import {errorMessageAlert} from '@/helpers/alert'
import RemindSettingList from './CMRemindSettingList.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

export default {
  components: {
    'cm-remind-setting-list': RemindSettingList,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      remindSettings: []
    }
  },
  created () {
    this.$bus.$on('refresh-cache-remind-settings', () => {
      this.remindSettings = this.$engine.settings.remindSettings.get()
    })
  },
  mounted () {
    this.remindSettings = this.$engine.settings.remindSettings.get()
  },
  beforeDestroy () {
  },
  methods: {
    sendPayments () {
    },
    sendAllReadyPayments () {
    }
  }
}
</script>
<style>
/* TLV 02/12/2019
* Sur les pages de Settings, le formulaire de recherche est plus bas
*/
@media (min-width:992px) {
  .remindsetting {
    margin-top:8%;
    margin-left:25%;
  }
}
</style>
